import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const links = [
    { name: "Blog", href: "/blog" },
    { name: "About Us", href: "/about" },
    { name: "Terms", href: "/terms" },
    { name: "Privacy Policy", href: "/policy" },
    { name: "Cookie Policy", href: "/cookie-policy" },
    { name: "Disclaimer", href: "/disclaimer" },
    { name: "Contact Us", href: "/contact" }
  ];

  return (
    <footer className="w-full py-8 mt-12 border-t border-border bg-background/50 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} SuperTags. All rights reserved.
        </div>
        
        <nav className="flex flex-wrap justify-center gap-6">
          {links.map((link) => (
            <Link 
              key={link.name} 
              to={link.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.name}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
